import { render, staticRenderFns } from "./BaseEditionPanel.vue?vue&type=template&id=2be0e2fc&scoped=true&"
import script from "./BaseEditionPanel.vue?vue&type=script&lang=js&"
export * from "./BaseEditionPanel.vue?vue&type=script&lang=js&"
import style0 from "./BaseEditionPanel.vue?vue&type=style&index=0&id=2be0e2fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be0e2fc",
  null
  
)

export default component.exports